import { Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import {  Subject } from 'rxjs';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
var moment = require('moment');
import { CommonFunction } from 'src/app/helpers/commonFunction';
@Component({
  selector: 'app-director',
  templateUrl: './director.component.html',
  styleUrls: ['./director.component.css']
})
export class DirectorComponent implements OnInit {
  isSearchDivVisible = false;

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response:boolean;
  constructor(private directorMasterService: DirectorMasterService, private router: Router, private commonFunction: CommonFunction,
    private alert: AlertComponent,private route: ActivatedRoute) { 
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.getMasterDirectorList();
    this.getRegisterDirectorList();
    this.FromDateModelInMasterDirector = null;
    this.ToDateModelInMasterDirector = null;

    this.dtOptionsOfMasterDirector = {
      destroy: true,
      scrollY: "300px",
      scrollX: true,
      scrollCollapse: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [8] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Directors List',
          title: 'Directors List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,3,5,6,7],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ]
    };
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Register Director List',
          title: 'Register Director List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2,3,4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ]
    };
    
  if (searchflag == 'true') {
      
    var filterDate = JSON.parse(localStorage.getItem('inputdatadirectors'));
  
   if(filterDate.ToDate !=null)
   {
    let dt = new Date(this.commonFunction.setFormatDate(filterDate.ToDate))
    this.ToDateModelInMasterDirector={ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
   }

   if(filterDate.FromDate !=null)
   {
    let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
    this.FromDateModelInMasterDirector={ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
   }
 // localStorage.removeItem('searchdireflag');
 //localStorage.setItem('searchdireflag', 'false');
   } else {
    filterDate = {
      FromDate: null,
      ToDate: null,
    }
  }
}

  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if(directorData.length){
    this.masterDirectorList = [];
    $("#directormasterTable").DataTable().destroy();
    this.masterDirectorList = directorData;
    this.dtTriggerMasterDirector.next();
    setTimeout(() => {
      $("#directormasterTable").DataTable().columns.adjust().draw();
    }, 200);
  }
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getMasterDirectorList() {
    this.masterDirectorList = [];
    let searchflag = localStorage.getItem('searchdireflag');
    var filterDate;
    if (searchflag == 'true') {
      
      filterDate = JSON.parse(localStorage.getItem('inputdatadirectors'));
    
     
     
      let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
      this.FromDateModelInMasterDirector={ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      let dt2 = new Date(this.commonFunction.setFormatDate( filterDate.ToDate))
      this.ToDateModelInMasterDirector = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
    }
    else {
      filterDate = {
        FromDate: null,
        ToDate: null,
      }
    }
    this.directorMasterService.getMasterDirector(filterDate)
      .subscribe(masterDirectorList => {
        this.masterDirectorList = (masterDirectorList && masterDirectorList.status == 0 && masterDirectorList.directorList)
          ? masterDirectorList.directorList
          : [];
        this.dtTriggerMasterDirector.next();
      }, () => {
        this.masterDirectorList = [];
        this.dtTriggerMasterDirector.next();
      });
  }
  loadDirectorDateById(directorId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['director', 'edit',directorId]  } }],
      { relativeTo: this.route.parent }); 
    // this.router.navigate(['/director/edit/', directorId]);
  }

  getRegisterDirectorList() {
      
    // localStorage.setItem('searchdireflag', 'false');
    // localStorage.removeItem('searchdireflag');
    this.registerDirectorList = [];
    this.directorMasterService.getRegisterDirector()
      .subscribe(registerList => {
          
        if (registerList && registerList.status == 0 && registerList.registerDirectorList) {
          for (var i = 0; i < registerList.registerDirectorList.length; i++) {
            if (registerList.registerDirectorList[i].Directorship.length > 0 ||
              registerList.registerDirectorList[i].SubDirector.length > 0) {


              this.registerDirectorList.push(registerList.registerDirectorList[i]);
            }
          }
          for (var i = 0; i < this.registerDirectorList.length; i++) {

            if (this.registerDirectorList[i].RegisterDirectorStatusList[this.registerDirectorList[i].RegisterDirectorStatusList.length - 1] == 'Rectified') {
              this.registerDirectorList[i].authStatus = this.registerDirectorList[i].RegisterDirectorStatusList[this.registerDirectorList[i].RegisterDirectorStatusList.length - 2];
            } else {
              this.registerDirectorList[i].authStatus = this.registerDirectorList[i].RegisterDirectorStatusList[this.registerDirectorList[i].RegisterDirectorStatusList.length - 1];
            }

          }
        }
          
        this.dtTriggerRegisterDirector.next();
      }, () => {
        this.registerDirectorList = [];
        this.dtTriggerRegisterDirector.next();
      });
  }

  loadauthorizeData(directorId) {
    var authenticate = "authenticate";
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['register', 'edit',directorId,authenticate]  } }],
      { relativeTo: this.route.parent }); 
    // this.router.navigate(['/register/edit/', directorId, authenticate]);
  }

  loadrectifyData(directorId) {
    var rectify = "rectify";
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['register', 'edit',directorId,rectify]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/register/edit/', directorId, rectify]);
  }



  getDirectorByParam() {
    this.response = true;
    localStorage.setItem('searchdireflag', 'true');
    this.futureFromDate = null;
    this.futureToDate = null;
    this.masterDirectorList = [];
    var filterDate = {
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInMasterDirector != null && this.ToDateModelInMasterDirector == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInMasterDirector).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInMasterDirector == null && this.ToDateModelInMasterDirector != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInMasterDirector).toString();
    }
    if (this.FromDateModelInMasterDirector != null && this.ToDateModelInMasterDirector != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInMasterDirector).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInMasterDirector).toString();
    }
    if (this.FromDateModelInMasterDirector == null && this.ToDateModelInMasterDirector == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    // var table = $('#directormasterTable').DataTable({ destroy: true });
    // table.destroy();
    localStorage.setItem('inputdatadirectors', JSON.stringify(filterDate));
    this.directorMasterService.getMasterDirector(filterDate)
      .subscribe(masterDirectorData => {
        if (masterDirectorData.status == 0) {
          this.masterDirectorList = masterDirectorData.directorList;
          this.response = false;
        }
      });
    //this.dtTriggerMasterDirector.next();
    this.adjustdirectormasterTable();
  //   $('#adjustdirectormasterTable').DataTable().ajax.reload();
  //    this.response = false;
  }


  getDirectorByNullParam() {
    this.response = true;
    this.futureFromDate = null;
    this.futureToDate = null;
    this.FromDateModelInMasterDirector = null;
    this.ToDateModelInMasterDirector = null;
    this.masterDirectorList = [];
    localStorage.setItem('searchdireflag', 'false');
    
    var filterDate = {
      FromDate: null,
      ToDate: null,
    }
    localStorage.setItem('inputdatadirectors',JSON.stringify(filterDate))
    // var table = $('#directormasterTable').DataTable({ destroy: true });
    // table.destroy();
    this.directorMasterService.getMasterDirector(filterDate)
      .subscribe(masterDirectorData => {
        if (masterDirectorData.status == 0) {
          this.masterDirectorList = masterDirectorData.directorList;
          this.response = false;
        }
      });
    // this.dtTriggerMasterDirector.next();
    this.adjustdirectormasterTable();
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directorRegisterTable").DataTable().columns.adjust().draw();
    });
  }

  setTodate(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDate = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdate(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDate = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }
  generateMbp4bDocument() {
    this.directorMasterService.generateMbp4bDocument(null).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        this.downloadMbp4BDocument();
        this.downloadMbp4BPdfDocument();
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadMbp4BDocument() {
    this.directorMasterService.downloadMbp4bFile(null);
  }
  downloadMbp4BPdfDocument() {
    this.directorMasterService.downloadMbp4bPdfFile(null);
  }

  exportRegisterOfDirectorToPdf(directorId){
      this.directorMasterService.exportRegisterOfDirectorsToPdf(directorId).subscribe((response:any) => {        
        var path = response.filePath ;
        path.replace('\\', '/')
        
        window.open(path , "_blank")

      } , 
      error => {
        console.log("error", error);
      })
  }

}
